import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import { useLocation, useSearchParams } from 'react-router-dom'

export default function VolunteerNotFound() {
  const { t } = useTranslation()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const message =
    searchParams.get('message') ||
    (location.state as { message?: string } | null)?.message

  return (
    <div className="w-full min-h-screen flex align-items-center justify-content-center flex-column gap-6 p-4">
      <div className="text-center">
        <p className="text-2xl font-bold">{t('Page not found')}</p>
        {message ? (
          <p className="text-color-secondary line-height-3 m-0">{message}</p>
        ) : null}
      </div>
      <Button
        size="large"
        onClick={() => {
          window.location.replace('/')
        }}
      >
        {t('Go to home page')}
      </Button>
    </div>
  )
}
